// extracted by mini-css-extract-plugin
module.exports = {"menu-list":"styles_menu-list__WaKUA","item":"styles_item__ufs9v","icon":"styles_icon__aBwqo"};